import { ChoiceDataType, DeleteResponse } from '../types/choice';
import baseApi from './base';
import { ChoicesTag, QuestionTag } from './tags';

interface PostChoice {
  id: string;
  content: {
    content: string;
    lcmsReferenceIds: any;
    choiceMetadata: {
      position: number;
      type: number;
    };
  };
}

interface UpdateResponse extends DeleteResponse {
  generatedMaps: any[];
}

const choiceApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getChoices: build.query<ChoiceDataType[], { questionId: string }>({
      query: (param) => `choices?question-id=${param.questionId}`,
      providesTags: [ChoicesTag],
    }),
    createChoice: build.mutation<ChoiceDataType, PostChoice>({
      query: (choiceData) => ({
        url: `/choices/${choiceData.id}`,
        body: choiceData.content,
        method: 'POST',
      }),
      invalidatesTags: [ChoicesTag, QuestionTag],
    }),
    updateChoice: build.mutation<UpdateResponse, PostChoice>({
      query: (choiceData) => ({
        url: `/choices/${choiceData.id}`,
        body: choiceData.content,
        method: 'PUT',
      }),
      invalidatesTags: [ChoicesTag, QuestionTag],
    }),
    deleteChoice: build.mutation<DeleteResponse, string>({
      query: (id) => ({
        url: `/choices/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [ChoicesTag, QuestionTag],
    }),
  }),
});

export const {
  useGetChoicesQuery,
  useCreateChoiceMutation,
  useUpdateChoiceMutation,
  useDeleteChoiceMutation,
} = choiceApi;
export default choiceApi;
